import { HardDrive } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const DatasetIcon = DeckardIconWrapper({ Icon: HardDrive });
